module.exports = __webpack_public_path__ + "static/media/B.a8e2591c.png";